import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { COMPONENT_LIST_INIT_SORT } from "../constants";
import { networkingApi } from "../report/services/networking.api";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
/** Initial state for networking table filter */
export const initFilter = {
    search_regex: "",
    has_services: false,
    tag: "ALL",
    classification: "ALL",
    uri_id: null,
};
/** Initial state for networking table sort */
export const initSort = {
    property: "tag_count",
    reverse: true,
};
/** Initial state for networking table pagination */
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    expandedRows: {},
    focusedRow: null,
    filteredByLink: false,
};
const networkingSlice = createSlice({
    name: "networking",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            state.filter.uri_id = null;
            state.filteredByLink = false;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
        },
        filteredByUri: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.uri_id = action.payload.id;
            state.filter.search_regex = action.payload.value;
            state.filteredByLink = true;
            state.expandedRows = {
                [action.payload.id]: {
                    pagination: initPagination,
                    sortBy: COMPONENT_LIST_INIT_SORT,
                },
            };
            state.focusedRow = action.payload.id;
            state.pagination.currentPage = 1;
        },
        sortUpdated: (state, action) => {
            state.sort = action.payload;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
            state.expandedRows = {};
        },
        focusedRowUpdated: (state, action) => {
            state.focusedRow = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows[action.payload.id] = {
                    pagination: initPagination,
                    sortBy: COMPONENT_LIST_INIT_SORT,
                };
            }
            else {
                delete state.expandedRows[action.payload.id];
            }
        },
        expandedRowPaginationUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].pagination =
                    action.payload.pagination;
            }
        },
        expandedRowSortUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].sortBy = action.payload.sort;
                state.expandedRows[action.payload.id].pagination.currentPage = 1;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "networking");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
        builder.addMatcher(networkingApi.endpoints.getNetworking.matchFulfilled, (state, action) => {
            if (!state.filteredByLink || action.payload.match_count !== 1)
                return;
            state.expandedRows[action.payload.networking[0].id] = {
                pagination: initPagination,
                sortBy: COMPONENT_LIST_INIT_SORT,
            };
            state.focusedRow = action.payload.networking[0].id;
        });
    },
});
export const networkingReducer = networkingSlice.reducer;
export const { filterUpdated, filteredByUri, sortUpdated, paginationUpdated, expandedRowsUpdated, expandedRowPaginationUpdated, expandedRowSortUpdated, focusedRowUpdated, } = networkingSlice.actions;
export const selectFilter = (state) => state.report.networking.filter;
export const selectFilteredByLink = (state) => state.report.networking.filteredByLink;
export const selectSort = (state) => state.report.networking.sort;
export const selectPagination = (state) => state.report.networking.pagination;
export const selectExpandedRow = (state, id) => state.report.networking.expandedRows[id] !== undefined;
export const selectExpandedRowPagination = (state, id) => { var _a; var _b; return (_b = (_a = state.report.networking.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.pagination) !== null && _b !== void 0 ? _b : initPagination; };
export const selectExpandedRowSort = (state, id) => { var _a; var _b; return (_b = (_a = state.report.networking.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.sortBy) !== null && _b !== void 0 ? _b : COMPONENT_LIST_INIT_SORT; };
export const selectFocusedRow = (state) => state.report.networking.focusedRow;
export * as default from "./networkingSlice";
//# sourceMappingURL=networkingSlice.js.map